import styled from 'styled-components/macro';
import { Typography } from 'antd';

const { Text } = Typography;

const CustomText = styled(Text)`
  color: ${(props) => props.color} !important;
  font-size: ${(props) => props.fontSize};
  font-weight: ${(props) => props.fontWeight};
  height: ${(props) => props.height};
  line-height: ${(props) => props.lineheight};
  margin-left: ${(props) => props.marginleft};
  margin-top: ${(props) => props.margintop};
  margin-bottom: ${(props) => props.marginbottom};
  margin-right: ${(props) => props.marginright};
  text-decoration: ${(props) => props.textDecoration};
  type: ${(props) => props.type};
`;

export default CustomText;
